<template>
  <modal name="initPasswordPopup" :clickToClose="false"
      @before-open="beforeOpen"
      @opened="opened">

    <div id="div_initPasswordPopup" class="popup pw_reset" style="z-index:999">
      <div class="alert_popup">
        <div class="alert_wrap">
          <div class="message">
            <span>비밀번호 초기화</span>
            <form action="">
              <fieldset>
                <div class="login_input">
                  <div class="id row">
                    <label for=""></label>
                    <input type="text" name="아이디" @keyup.enter="login" v-model="form.userId" v-validate="'required'" placeholder="아이디">
                    <div class="lo_validation" v-if="errors.has('아이디')">
                      <div class="lo_tri"></div>
                      <span>{{ errors.first('아이디') }}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
            <form action="">
              <fieldset>
                <div class="confirm row">
                  <div class="number row">
                    <label for=""></label>
						        <input type="text" v-model="form.authNumber" placeholder="인증번호를 입력해 주세요">
                    <timeCounter ref="commonTimeCounter" :startTime="authNumberTime" />
                  </div>
                  <div class="con_btn">
                    <button type="button" @click="getAuthNumber">인증번호 요청</button>
                  </div>                  
                </div>
              </fieldset>
            </form>
          </div>
          <div class="alert_btn">
            <button type="button" @click="initPassword">확인</button>
            <button type="button" class="cancel" @click="close">취소</button>
          </div>
          <button class="close" @click="close"><i class="xi-close-min"></i></button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import TimeCounter from '@/components/TimeCounter'
import Utils from '@/modules/utils'
import {locale, loadMessages, formatMessage } from 'devextreme/localization'
import DxTextBox from 'devextreme-vue/text-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxEmailRule,
  DxPatternRule,
  DxStringLengthRule,
  DxRangeRule
} from 'devextreme-vue/validator'

export default {
  name: 'initPasswordPopup',
  components: { 
    TimeCounter,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxValidationGroup,
    DxTextBox
  },
  data: () => ({
    form: {
      userId: '',
      authNumber: ''
    },
    authNumberTime: 180
  }),  
  methods: {
    formatMessage:formatMessage,
    beforeOpen(e) {

      // 파라미터 초기화
      Utils.initObject(this.form, false);      

    },
    opened(e) {  

			var popLeft = (($(window).width() - $('#div_initPasswordPopup').outerWidth()) / 2);
			var popTop = (($(window).height() - $('#div_initPasswordPopup').outerHeight()) / 2 );
			if(popLeft < 0) popLeft = 0;
			if(popTop < 0) popTop = 0;
			$('#popupMask').fadeIn();
			$('#div_initPasswordPopup').css({"left":popLeft, "top":popTop}).fadeIn().addClass('on');

			$(".mscroll").mCustomScrollbar( {
				theme: "dark-thick",
				scrollInertia: 600
			});    
    },
    getAuthNumber () {
      if (this.form.userId == null || this.form.userId == '') { 
        Vue.Alert.alert('먼저 아이디를 입력하십시오.');
        return; 
      }

      // 인증번호 전송 요청
      Vue.httpClient
      .post('/app/public/authnumber', this.form)
      .then((response) => {
        if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
          if ( response.data.result != undefined ) {
            Vue.Alert.alert(response.data.result);
          }

          this.$refs.commonTimeCounter.startCounter();
        }  
      })
      .catch(e => {
        if (e.result.status == AppConfig.NO_ID) {
          Vue.Alert.alert('존재하지 않는 ID 입니다.');
        }
      })          
    },    
    initPassword() {
      this.$validator.validateAll()
        .then((success) => {
          if (!success) { return; }

          // 비밀번호 초기화
          Vue.httpClient
          .post('/app/public/login/password/initialize', this.form)
          .then((response) => {
            if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              if ( response.data.result != undefined ) {
                Vue.Alert.alert(response.data.result);
              }

              this.$modal.hide('initPasswordPopup');
            } 
          }) 
          .catch(e => {
            if (e.result.status == AppConfig.AUTH_NUMBER_FAIL) {
              Vue.Alert.alert('인증번호를 잘못 입력하셨습니다.');
            }
          })                   
        });
    },
    close() {
      this.$modal.hide('initPasswordPopup');
    }    
  }
}
</script>


// WEBPACK FOOTER //
// src/views/common/InitPasswordPopup.vue